export default {
  'Add Cut': 'カットを追加',
}